// src/pages/Contact.tsx
import React from 'react';
import { Link } from 'react-router-dom';

import { useHorizontalScroll } from '../hooks/useHorizontalScroll';

import { useScrollingText } from "../hooks/useScrollingText";

const TestimonialSection: React.FC = () => {

useHorizontalScroll([
  { wrapperClass: '.testimonial-scroll-wrapper', itemClass: '.testimonial-scroll-item' }
]);


useScrollingText([
  {
    selector: ".testimonial-scroll-text",
    direction: "left",
    scrollEffect: true,
    infinite: true,
  },
]);


  return (


<>



<div className="rts-use-case-area-one">


  <div className="container-full">
    <div className="col-lg-12">
      <div className="main-wrapper-case-studies scrolltext-wrapper">
        <div className="testimonial-scroll-text">
          <h2 className="title">
            Testimonials . Testimonials . Testimonials . Testimonials .
          </h2>
        </div>
      </div>
    </div>
  </div>



  {/* ==== banner start ==== */}
  <div className="testimonial-section">

    <div className="testimonial-scroll-wrapper d-flex flex-md-row flex-column">







{/* ==== Testimonial Start ==== */}
      <div className="testimonial-scroll-item pb--30">
        <div className="projects-s__single topy-tilt">


  <div className="single-testimonials-main-wrapper testimonial-bg">
    <div className="star-area-start">
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
    </div>
    <div className="body">
      <p className="disc">
        &quot;Manikarn Digital completely revamped our outdated website into a modern, user-friendly platform. Their design and development team was professional, responsive, and truly brought our brand vision to life.&quot;
      </p>
      <div className="author-area">
        <div className="info-wrapper">
          <h6 className="title">Emily Carter – USA</h6>
        </div>
      </div>
    </div>
  </div>



        </div>
      </div>

{/* ==== Testimonial End ==== */}


{/* ==== Testimonial Start ==== */}
      <div className="testimonial-scroll-item pt--30">
        <div className="projects-s__single topy-tilt">


  <div className="single-testimonials-main-wrapper testimonial-bg">
    <div className="star-area-start">
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
    </div>
    <div className="body">
      <p className="disc">
        &quot;Thanks to Manikarn Digital&apos;s strategic digital marketing services, we&apos;ve seen a noticeable increase in website traffic and customer engagement. Their SEO and social media efforts are incredibly effective.&quot;
      </p>
      <div className="author-area">
        <div className="info-wrapper">
          <h6 className="title">Arjun Mehta – India</h6>
        </div>
      </div>
    </div>
  </div>



        </div>
      </div>

{/* ==== Testimonial End ==== */}




{/* ==== Testimonial Start ==== */}
      <div className="testimonial-scroll-item pb--30">
        <div className="projects-s__single topy-tilt">


  <div className="single-testimonials-main-wrapper testimonial-bg">
    <div className="star-area-start">
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
    </div>
    <div className="body">
      <p className="disc">
        &quot;We hired Manikarn Digital for graphic designing, and the results were fantastic. Their creativity, attention to detail, and understanding of brand identity exceeded all our expectations. Highly recommended!&quot;
      </p>
      <div className="author-area">
        <div className="info-wrapper">
          <h6 className="title">Sarah Jensen – Australia</h6>
        </div>
      </div>
    </div>
  </div>



        </div>
      </div>

{/* ==== Testimonial End ==== */}


{/* ==== Testimonial Start ==== */}
      <div className="testimonial-scroll-item pt--30">
        <div className="projects-s__single topy-tilt">


  <div className="single-testimonials-main-wrapper testimonial-bg">
    <div className="star-area-start">
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
    </div>
    <div className="body">
      <p className="disc">
        &quot;With Manikarn&apos;s website care services, our site remains updated, secure, and running smoothly. It&apos;s like having an in-house tech team, but more affordable and incredibly dependable.&quot;
      </p>
      <div className="author-area">
        <div className="info-wrapper">
          <h6 className="title">Jonathan Kim – South Korea</h6>
        </div>
      </div>
    </div>
  </div>



        </div>
      </div>

{/* ==== Testimonial End ==== */}









{/* ==== Testimonial Start ==== */}
      <div className="testimonial-scroll-item pb--30">
        <div className="projects-s__single topy-tilt">


  <div className="single-testimonials-main-wrapper testimonial-bg">
    <div className="star-area-start">
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
    </div>
    <div className="body">
      <p className="disc">
        &quot;We migrated to Manikarn&apos;s hosting and support services, and the experience has been flawless. Their fast servers and responsive support team make website management stress-free and efficient.&quot;
      </p>
      <div className="author-area">
        <div className="info-wrapper">
          <h6 className="title">Priya Nair – UAE</h6>
        </div>
      </div>
    </div>
  </div>



        </div>
      </div>

{/* ==== Testimonial End ==== */}


{/* ==== Testimonial Start ==== */}
      <div className="testimonial-scroll-item pt--30">
        <div className="projects-s__single topy-tilt">


  <div className="single-testimonials-main-wrapper testimonial-bg">
    <div className="star-area-start">
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
    </div>
    <div className="body">
      <p className="disc">
        &quot;Manikarn Digital delivered a fully customized website ahead of schedule. Their development process was smooth, and they were very responsive to feedback. A reliable partner for any web project.&quot;
      </p>
      <div className="author-area">
        <div className="info-wrapper">
          <h6 className="title">Michael Thompson – UK</h6>
        </div>
      </div>
    </div>
  </div>



        </div>
      </div>

{/* ==== Testimonial End ==== */}




{/* ==== Testimonial Start ==== */}
      <div className="testimonial-scroll-item pb--30">
        <div className="projects-s__single topy-tilt">


  <div className="single-testimonials-main-wrapper testimonial-bg">
    <div className="star-area-start">
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
    </div>
    <div className="body">
      <p className="disc">
        &quot;Our online visibility skyrocketed after Manikarn Digital took over our digital marketing. Their targeted strategies brought measurable results, and we saw a boost in leads within just a few weeks.&quot;
      </p>
      <div className="author-area">
        <div className="info-wrapper">
          <h6 className="title">Ana Rodríguez – Spain</h6>
        </div>
      </div>
    </div>
  </div>



        </div>
      </div>

{/* ==== Testimonial End ==== */}


{/* ==== Testimonial Start ==== */}
      <div className="testimonial-scroll-item pt--30">
        <div className="projects-s__single topy-tilt">


  <div className="single-testimonials-main-wrapper testimonial-bg">
    <div className="star-area-start">
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
    </div>
    <div className="body">
      <p className="disc">
        &quot;I&apos;ve worked with several agencies before, but Manikarn&apos;s support team truly stands out. They&apos;re quick, friendly, and always solve issues before they become real problems. Exceptional service!&quot;
      </p>
      <div className="author-area">
        <div className="info-wrapper">
          <h6 className="title">Daniel Kowalski – Poland</h6>
        </div>
      </div>
    </div>
  </div>



        </div>
      </div>

{/* ==== Testimonial End ==== */}

{/* ==== Testimonial Start ==== */}
      <div className="testimonial-scroll-item pb--30">
        <div className="projects-s__single topy-tilt">


  <div className="single-testimonials-main-wrapper testimonial-bg">
    <div className="star-area-start">
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
    </div>
    <div className="body">
      <p className="disc">
        &quot;With their website care plan, we never worry about updates, backups, or performance. The Manikarn team handles everything proactively, allowing us to focus on growing our business.&quot;
      </p>
      <div className="author-area">
        <div className="info-wrapper">
          <h6 className="title">Fatima Al-Mansoori – Qatar</h6>
        </div>
      </div>
    </div>
  </div>



        </div>
      </div>

{/* ==== Testimonial End ==== */}


{/* ==== Testimonial Start ==== */}
      <div className="testimonial-scroll-item pt--30">
        <div className="projects-s__single topy-tilt">


  <div className="single-testimonials-main-wrapper testimonial-bg">
    <div className="star-area-start">
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
      <i className="fa fa-star" style={{ color: 'var(--primary-color)' }}></i>
    </div>
    <div className="body">
      <p className="disc">
        &quot;Manikarn Digital&apos;s graphic design services helped elevate our brand image. The visuals they delivered were professional, eye-catching, and perfectly aligned with our marketing goals. We&apos;ll definitely work with them again!&quot;
      </p>
      <div className="author-area">
        <div className="info-wrapper">
          <h6 className="title">Lucas Martins – Brazil</h6>
        </div>
      </div>
    </div>
  </div>



        </div>
      </div>

{/* ==== Testimonial End ==== */}





    </div>
  </div>
  {/* ==== / banner end ==== */}


</div>


</>




  );
};

export default TestimonialSection;
